import React, { useState, useEffect } from "react";
import Menu from "../Menu/Menu";
import Content from "../Content/Content";
import AnnouncementPage from "../AnnouncementPage/AnnouncementPage";
import Student from "../Student/Student";
import Attendance from "../Attendance/Attendance";
import Teacher from "../Teacher/Teacher";
import CircularPage from "../Circularpage/Circularpage";
import Assignmentpage from "../Assignmentpage/Assignmentpage";
import AdmissionList from "../AdmissionList/AdmissionList";
import Admin from "../Admin/Admin";
import PrivacyPolicy from "../Privacypolicy/Privacypolicy";
import AttendanceReport from "../AttendanceReport/AttendanceReport";
import AssignmentReport from "../AssignmentReport/AssignmentReport";
import ResultReport from "../ResultsReport/MainReport"; // ✅ Added

import "./Hero.css";

function Hero() {
  const [activePage, setActivePage] = useState(
    localStorage.getItem("activePage") || "Overview"
  );

  const [isMenuOpen, setIsMenuOpen] = useState(
    JSON.parse(localStorage.getItem("isMenuOpen")) ?? true
  );

  useEffect(() => {
    localStorage.setItem("activePage", activePage);
  }, [activePage]);

  useEffect(() => {
    localStorage.setItem("isMenuOpen", JSON.stringify(isMenuOpen));
  }, [isMenuOpen]);

  const renderPage = () => {
    switch (activePage) {
      case "Overview":
        return <Content />;
      case "Announcement":
        return <AnnouncementPage />;
      case "AdmissionList":
        return <AdmissionList />;
      case "Student":
        return <Student />;
      case "Teacher":
        return <Teacher />;
      case "Attendance":
        return <Attendance />;
      case "Circular":
        return <CircularPage />;
      case "Assignment":
        return <Assignmentpage />;
      case "Admin":
        return <Admin />;
      case "Privacy Policy":
        return <PrivacyPolicy />;
      case "Terms of Use":
        return <TermsOfUse />;
      case "AttendanceReport":
        return <AttendanceReport />;
      case "AssignmentReport":
        return <AssignmentReport />;
      case "ResultReport": // ✅ Added case
        return <ResultReport />;
      default:
        return <Content />;
    }
  };

  return (
    <div className={`hero ${isMenuOpen ? "menu-open" : "menu-closed"}`}>
      <Menu
        onMenuClick={setActivePage}
        isOpen={isMenuOpen}
        toggleMenu={() => setIsMenuOpen(!isMenuOpen)}
      />

      <div className={`page-content ${isMenuOpen ? "expanded" : "full-width"}`}>
        {renderPage()}
      </div>
    </div>
  );
}

export default Hero;
